<template>
  <div class="send-wrap">
    <div id="send">
      <h1 class="top-title">
        <picture>
          <source srcset="@/assets/img/pc/ttl_thanks.svg" media="(min-width: 681px)" />
          <source srcset="@/assets/img/sp/ttl_thanks.svg" media="(max-width: 680px)" />
          <img src="@/assets/img/pc/ttl_thanks.svg" alt="お問い合わせありがとうございます">
        </picture>
      </h1>
      <p class="text">お問い合せを受け付けました。</p>
      <p class="text">1営業日以内に担当者よりご連絡いたします。</p>
      <div class="space"></div>
      <p class="text">※お問い合せ完了後、<br class="sp-br">自動返信メールが送信されます。</p>
      <p class="text">24時間以内に自動返信メールが<br class="sp-br">届かない場合は、再度お問合せいただくか、</p>
      <p class="text">弊社番号：<a href="tel:0268710740" class="tel">0268-71-0740</a>まで<br class="sp-br">ご連絡ください。</p>
      
      <div @click="click" class="btn" ontouchstart=””>
        <picture>
          <source srcset="@/assets/img/sp/btn_top.svg" media="(min-width: 681px)" />
          <source srcset="@/assets/img/sp/btn_top.svg" media="(max-width: 680px)" />
          <img src="@/assets/img/sp/btn_top.svg" alt="TOPに戻る" class="img">
        </picture>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    window.scrollTo({
      top: 0,
    })
  },
  methods: {
    click: function(){
      this.$router.push({
        name: 'Top',
      })
    }
  }

}
</script>